import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useState, useRef} from 'react';
import {ReactiveTable} from "react-ive-tables";
import {ComponentContainer} from "../../../lib/template/ComponentContainer";
import useSWR from "swr";
import {
    InvoiceWithPayment,
    ProcessedBankTransactionResponse,
    UnprocessedBankTransactionResponse, UnrecognizedBankTransaction
} from "../../../lib/types/types";
import {LazyFetchingService} from "../../../lib/services/lazy-fetching-service";
import {formatNumber} from "../../../lib/common";
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {IDropdownOption} from "@xal3xfx/react-utils/dist/util-service";
import {Dialog} from "primereact/dialog";
import {DataTableRowEvent, DataTableRowToggleEvent} from "primereact/datatable";
import {Payments} from "../../invoices/Payments";
import TransactionPayments from "./TransactionPayments";
import moment from "moment/moment";

interface Props {

}

const lazyFetchingService = new LazyFetchingService<ProcessedBankTransactionResponse>('/bank/transactions/processed/lazy');


const ProcessedTransactions : React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);

    const [showPaymentsDialog, setShowPaymentsDialog] = useState(false);
    const [expandedRows, setExpandedRows] = useState<any>([]);

    const fetchData = lazyFetchingService.getDataFetcher;
    const fetcher = lazyFetchingService.getLazyFetcher;

    const {data: processedTransactionsTableData} = useSWR<Awaited<ReturnType<typeof fetcher>>, Error>(`/bank/transactions/processed/lazy`, {fetcher: fetcher});
    const {data: clientOptions} = useSWR<IDropdownOption[], Error>('/clients/dropdown');

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const getDiscardReasonTemplate = (rowData: ProcessedBankTransactionResponse) => {
        if(rowData.discardReason) {
            return <div>
                {`${rowData.discardReason}`}
                <br/>
                {`${f({id: "remainingAmount"})} - ${formatNumber(rowData.remainingAmount)}`}
            </div>
        }
    }
    const rowClass = (data: ProcessedBankTransactionResponse) => {
        return {
            'overdue-invoice': data.discardReason !== null
        }
    }


    const getColumnTemplate = () => {
        return {
            valueDate: (rowData: ProcessedBankTransactionResponse) => moment(rowData.valueDate).format("DD-MM-YYYY"),
            clientId: (rowData: ProcessedBankTransactionResponse) => rowData.clientName,
            amount: (rowData: ProcessedBankTransactionResponse) => formatNumber(rowData.amount),
            discardReason: getDiscardReasonTemplate
        }
    }

    const getSpecialFilters = () => {
        return {
            clientId: (options: any) => <Dropdown filter={true} showClear value={options.value}
                                                  resetFilterOnHide
                                                  filterInputAutoFocus={true}
                                                  options={clientOptions}
                                                  optionValue={'id'} optionLabel={'description'}
                                                  placeholder={f({id: 'chooseLabel'})}
                                                  onChange={(e) => options.filterApplyCallback(e.value)}
                                                  style={{textAlign: "left"}}/>,

        }
    }

    const rowExpansionTemplate = (data: ProcessedBankTransactionResponse) => {
        return <TransactionPayments selectedBankTransaction={data}/>
    }

    const onRowToggle = (event: DataTableRowToggleEvent) => {
        setExpandedRows(event.data);
    }

    return <>
        <ComponentContainer componentName={f({ id: "processedTransactions" })}>

            <ReactiveTable
                swr
                data={processedTransactionsTableData?.rows}
                totalRecords={processedTransactionsTableData?.totalRecords}
                fetchData={fetchData}
                showHeader={false}
                columnTemplate={getColumnTemplate()}
                specialFilters={getSpecialFilters()}
                columnOrder={['clientId', 'bankReference', 'valueDate', 'amount', 'paymentDetails', 'discardReason']}
                expandable
                dtProps={{
                    className: 'p-datatable-no-select-outline invoices-table',
                    expandedRows,
                    rowExpansionTemplate,
                    onRowToggle,
                    rowClassName: rowClass,
                }}
            />

            <Dialog breakpoints={{'960px': '75vw', '640px': '100vw'}} style={{minWidth: '75vw'}} header={f({id: 'payments'})}
                    onHide={() => setShowPaymentsDialog(false)} visible={showPaymentsDialog}
            >

            </Dialog>
        </ComponentContainer>
    </>
};

export default ProcessedTransactions
